import { Zap, DollarSign, Leaf, Clock } from 'lucide-react';

const features = [
  {
    icon: Zap,
    title: 'Fast Service',
    description: 'Quick preparation & delivery'
  },
  {
    icon: DollarSign,
    title: 'Affordable Price',
    description: '₹1 - ₹200 price range'
  },
  {
    icon: Leaf,
    title: 'Fresh Ingredients',
    description: 'Quality ingredients daily'
  },
  {
    icon: Clock,
    title: 'Open Till 11:30 PM',
    description: 'Late night cravings sorted'
  }
];

export const FeaturesStrip = () => {
  return (
    <section className="section-container py-8 sm:py-12">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <div 
              key={index} 
              className="flex flex-col sm:flex-row items-center gap-3 p-4 sm:p-6 bg-card rounded-xl shadow-cafe-sm hover:shadow-cafe-md transition-shadow"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon className="w-6 h-6 text-primary" />
              </div>
              <div className="text-center sm:text-left">
                <h3 className="font-semibold text-sm sm:text-base text-foreground mb-1">{feature.title}</h3>
                <p className="text-xs sm:text-sm text-muted-foreground">{feature.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FeaturesStrip;